const PASSENGER = 'Passenger';
const EUROSTAR = 'Eurostar';

export const isFakeName = ({ firstName, lastName }) => firstName.includes(PASSENGER) && lastName === EUROSTAR;
